<template>
    <tr :ref="'tr_' + index">
        <td>{{ index }}</td>
        <td>{{ data.name }}</td>
        <td>{{ data.weight }}</td>
        <td>{{ data.color }}</td>
        <td><ui-badge :abbreviation="data.name" :color="data.color" design="sm" /></td>
        <td>
            <ui-menu-card>
                <button type="button" @click="openModal('modal-unity-values-add-category')">Editar</button>
                <button type="button" @click="deleteCategories(data.id)">Excluir</button>
            </ui-menu-card>
        </td>
    </tr>
</template>

<script>
	import { uiMenuCard } from '@/components/ui'
	import uiBadge from '@/components/ui/badge'
	import { groupsAvailability } from '@/services/axios'

	export default {
		components: {
			uiMenuCard,
			uiBadge,
		},

		props: {
			data: {
				type: Object,
				required: false,
				default: () => {}
			},

			index: {
				type: [String, Number],
				required: false,
				default: ''
			},
		},

		data: function () {
			return {
				legend: null,
				categories: [],
			}
		},

		beforeMount: function () {
			this.setLegend()
		},
		methods: {
			deleteCategories: function (id) {
				groupsAvailability
					.delete('', id)
					.then((response) => {
						this.$store.dispatch('productCategory/deleteProductCategory', response.data)
						this.$toastr.s(response.data.msg)
					})

					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log(error)
					})
			},

			setLegend: function () {
				this.legend = this.data.name
					.split(/\s/)
					.reduce((r, w) => (r += w.slice(0, 1)), '')
					.toUpperCase()
			},

			/**
			 * Abrir o Modal
			 */
			openModal(name) {
				this.$store.dispatch('productCategory/setProductCategory', this.data)
				this.$root.$emit('modal-open-' + name, false)
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
